module.exports = __webpack_public_path__ + "media/components/assets/img/icons/calendar-nr-37312f2580c927cb6fa143b5eff5675f.svg";